interface ScriptOptions extends Partial<HTMLScriptElement> {
  [key: string]: any; // Allow custom attributes like data-*
}

export const loadScript = (src: string, options: ScriptOptions = {}) =>
  new Promise<void>((resolve, reject) => {
    const scriptElem = document.createElement('script');

    // Set standard HTMLScriptElement properties
    Object.assign(scriptElem, {
      type: 'text/javascript',
      defer: true,
      src,
      onerror: (e: any) => {
        reject(e);
      },
      onload: () => {
        resolve();
      },
    });

    Object.entries(options).forEach(([key, value]) => {
      if (key.startsWith('data-') || key.startsWith('aria-') || key.includes('-')) {
        scriptElem.setAttribute(key, value);
      } else {
        (scriptElem as any)[key] = value;
      }
    });

    document.head.appendChild(scriptElem);
  });
